/**
 * State for process UI that must be available before the process collection is
 * loaded.
 */
export interface State {
  /** Whether the processes slideout is open. */
  isSlideoutOpen: boolean
}

export namespace State {
  export const INITIAL: State = {
    isSlideoutOpen: false,
  }
}
